export const FETCH_USER_BY_ADDRESS = 'FETCH_USER_BY_ADDRESS';
export const FETCH_USER_BY_ADDRESS_FAILED = 'FETCH_USER_BY_ADDRESS_FAILED';
export const FETCH_USER_BY_ADDRESS_SUCCEED = 'FETCH_USER_BY_ADDRESS_SUCCEED';
